<template>
<div class="main">

  <Hero v-if="this.showHero == true" :suburbname="suburbdata.suburb"></Hero>
  <div class="container">
    <AgentCard v-if='toggle' v-on:cannotAdd="cannotAdd" v-on:addToList="contactList" :agentdata="agentdata"></AgentCard>
    <LoadingSpinner v-if="this.loading == true"></LoadingSpinner>

    <div v-if="agentdata.length > 0" class="btnbox">
      <router-link :to="{name: 'shortlist'}" v-gaEvent="{ category: gacategory, action: 'Click Get Personalised Shortlist', label: 'Directory Panel'}" class="showmore ut-oa-btn">Get a personalised shortlist</router-link>
      <div @click="getMore()" v-gaEvent="{ category: gacategory, action: 'Click load more agents', label: 'See more local agents'}" v-if="this.pageAvaliable == true" class="showmore ut-oa-btn-inverse ut-font-semibold">See more local agents</div>
    </div>

    <div v-if="this.nodata == true && this.loading == false" class="nodata ut-mb-12 ut-mt-12 ut-px-4">
      <h3 class="ut-text-center ut-mb-4 ut-font-semibold ut-text-3xl">See a list of local agents in your&nbsp;area</h3>

      <SuburbSearch :placeholderText="'Enter your suburb or postcode'" class="suburbsearch suburbsearchhome" @selectedResult="getSuburb" :showIcon="true"></SuburbSearch>
    </div>

    <div v-if="this.loading == false" class="othersection ut-text-center ut-mx-6 ut-mb-20">

      <div class="howitworks ut-mb-24">
        <h2 class="ut-font-semibold ut-mb-4 ut-text-3xl">How our recommendation algorithm&nbsp;works</h2>
        <p class="ut-text-lg">We analyse every Australian property sale to select the best agents.</p>
        <div class="labimg ut-mt-12"></div>
      </div>

      <div class="inoneplace ut-pt-8">
        <h2 class="ut-font-semibold ut-mb-4 ut-text-3xl">Everything you need&nbsp;in&nbsp;once&nbsp;place</h2>
        <p class="ut-text-lg ut-mb-16">When you use OpenAgent to find a real&nbsp;estate&nbsp;agent&nbsp;you&nbsp;also&nbsp;get:</p>

        <div class="extras ut-text-left">
          <div class="extrasbox">
            <div class="extrasicon">
              <img src="@/assets/images/comprehensive_reports.svg">
            </div>
            <div class="extrastext">
              <p class="ut-font-semibold ut-mb-1 lg:ut-text-xl lg:ut-mt-4 lg:ut-mb-2">Comprehensive Reports</p>
              <p>Comprehensive suburb and property report so you know exactly where you stand</p>
            </div>
          </div>
          <div class="extrasbox">
            <div class="extrasicon">
              <img src="@/assets/images/access_to_experts.svg">
            </div>
            <div class="extrastext">
              <p class="ut-font-semibold ut-mb-1 lg:ut-text-xl lg:ut-mt-4 lg:ut-mb-2">Access to experts</p>
              <p>A team of experts standing by to help if ever you need it</p>
            </div>
          </div>
          <div class="extrasbox">
            <div class="extrasicon">
              <img src="@/assets/images/guides.svg">
            </div>
            <div class="extrastext">
              <p class="ut-font-semibold ut-mb-1 lg:ut-text-xl lg:ut-mt-4 lg:ut-mb-2">Guides</p>
              <p>Research and guides to make sure you have all the information at your finger tips</p>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>

  <div v-if="this.loading == false" class="joinus ut-text-center ut-font-semibold ut-text-xl lg:ut-text-2xl lg:ut-text-left lg:ut-flex">
    <p>Join the 2 million<sup class="ut-text-sm">*</sup> Australians who use OpenAgent&nbsp;every&nbsp;year</p>
    <router-link :to="{name: 'shortlist'}" v-gaEvent="{ category: gacategory, action: 'Click Get Personalised Shortlist', label: 'End Panel'}" class="showmore endshow ut-oa-btn ut-block ut-mt-8 ut-mb-24 lg:ut-mt-0">Get a personalised shortlist</router-link>
  </div>

  <div class="pageend"></div>

  <div v-if="this.agentContactList != null && this.agentContactList.length != 0" class="sticky-foot">
    <div v-for="(agent, key) in this.agentContactList">
      <img @click="removeAgent(agent)" v-gaEvent="{ category: gacategory, action: 'Click Agent Picture (Remove from Contact list)', label: `Agent ID ${agent.AgentId}`}" class="chs ut-cursor-pointer ut-headshot-sm ut-content-center ut-flex" :src="agent.AgentImageLink" />
    </div>
    <div v-if="this.agentContactList.length < 2" class="agentspace"></div>
    <div v-if="this.agentContactList.length < 3" class="agentspace"></div>
    <span @click="goToPage()" class="ut-float-right ut-cursor-pointer">Contact agents</span>
  </div>

  <Footer v-if="this.footerlegal != null" :footerlegal="this.footerlegal"></Footer>

  <modal :adaptive="true" :resizable="true" height="auto" class="ut-modal" name="addto-error">
    We recommend you start with three agents, please remove one of the agents from your list if you want to add this one
  </modal>

</div>
</template>

<script>
import axios from 'axios';
import Hero from '@/components/Hero.vue';
import AgentCard from '@/components/AgentCard.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import Footer from '@/components/Footer.vue';
import SuburbSearch from '@/components/forms/search/SuburbSearch.vue';

export default {
  name: 'Listing',
  components: {
    Hero,
    AgentCard,
    Footer,
    LoadingSpinner,
    SuburbSearch,
  },

  data() {
    return {
      showSearch: true,
      toggle: true,
      gacategory: "Directory with smart search",
      showItem: true,
      data: [],
      agentContactList: null,
      suburbdata: [],
      agentdata: [],
      posts: [],
      page: 1,
      pageAvaliable: true,
      loading: true,
      nodata: false,
      showHero: false,
      footerlegal: null,
      errors: [],
      showModal: false,
    };
  },
  methods: {
    getSuburb(selected) {
      this.suburbvar = selected;
      const query = {
        postcode: this.suburbvar.postcode,
        postcodeid: this.suburbvar.id,
        state: this.suburbvar.state,
        suburb: this.suburbvar.suburb,
      };
      this.$store.state.query = query;
      this.$router.push({
        name: 'Home',
        query: this.$store.state.query,
      });
      this.getMore();
    },
    removeAgent(agent) {
      console.log(agent);
      this.toggle = false;
      for (let i = 0; i < this.agentContactList.length; i++) {
        if (this.agentContactList[i].AgentKey == agent.AgentKey) {
          Object.assign(this.agentContactList[i], {
            hideMe: false
          });
          this.agentContactList.splice(i, 1);
        }
      }
      this.$store.state.agentContactList = this.agentContactList;
      this.toggle = false;
      this.$nextTick(() => {
        this.toggle = true;
      })
    },
    contactList(list) {
      this.agentContactList = list;
      this.$forceUpdate();
    },
    cannotAdd() {
      this.$modal.show('addto-error');
    },
    goToPage() {
      let agentKeys = '';

      this.agentContactList.forEach((agent) => {
        if (agentKeys == '') {
          agentKeys = `${agentKeys}${agent.AgentKey}`;
        } else {
          agentKeys = `${agentKeys}&${agent.AgentKey}`;
        }
      });

      this.$router.push({
        name: 'RequestAppraisalStep1',
        query: {
          ak: agentKeys,
        },
        params: {
          agents: this.agentContactList,
        },
      });
    },
    getMore() {
      this.loading = true;
      this.page++;
      axios.get(
          `${process.env.VUE_APP_API_URL}/SeoREST/geo-suburb-page?postcode=${this.$route.query.postcode}&suburb=${(this.$route.query.suburb == null ? null : this.$route.query.suburb.replace(' ', '-'))}&state=${this.$route.query.state}&sort=recent&page=${this.page}&limit=5`
        )
        .then((response) => {
          this.data = response.data.data;
          for (let i = 0; i < this.data.agents.length; i++) {
            this.agentdata.push(this.data.agents[i]);
          }
          this.loading = false;
          if (this.data.agents.length < 5) {
            this.pageAvaliable = false;
          }
          this.nodata = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },

  created() {

    if (this.$store.state.agentContactList != undefined) {
      this.agentContactList = this.$store.state.agentContactList;
    }

    this.$store.state.query = this.$route.query;

    if (this.$store.state.suburbdata != undefined) {
      this.suburbdata = this.$store.state.suburbdata;
      this.agentdata = this.$store.state.agentdata;
      this.showHero = true;
      this.loading = false;
      return;
    }

    axios.get(
        `${process.env.VUE_APP_API_URL}/SeoREST/geo-suburb-page?postcode=${this.$route.query.postcode}&suburb=${(this.$route.query.suburb == null ? null : this.$route.query.suburb.replace(' ', '-'))}&state=${this.$route.query.state}&sort=recent&page=${this.page}&limit=5`
      )
      .then((response) => {
        this.data = response.data.data;
        console.log(this.data);
        this.loading = false;

        if (this.data == null || this.data.agents.length < 1) {
          this.loading = false;
          this.nodata = true;
        }
        this.suburbdata = this.data.suburbdata;
        this.agentdata = this.data.agents;
        this.$store.state.suburbdata = this.suburbdata;
        this.$store.state.agentdata = this.agentdata;
        this.showHero = true;
      })
      .catch((e) => {
        this.showHero = true;
        this.errors.push(e);
      });

    axios.get(`${process.env.VUE_APP_API_URL}/articlerest/snippet/search?snippettitlelist=footer-legal`)
      .then((response) => {
        this.footerlegal = response.data.data[0];
      })
      .catch((e) => {
        this.errors.push(e);
      });

    // async / await version (created() becomes async created())
    //
    // try {
    //   const response = await axios.get(`${process.env.VUE_APP_API_URL}/SeoREST/geo-suburb-page?postcode=2153&suburb=baulkham-hills&state=nsw&sort=recent&page=1`)
    //   this.posts = response.data
    // } catch (e) {
    //   this.errors.push(e)
    // }
  },
};
</script>

<style scoped lang="scss">
.container {
    max-width: 1120px;
    margin: 0 auto;
    // min-height: -webkit-fill-available;
    // min-height: -moz-available;
    // min-height: fill-available;
    min-height: 70vh;
}
.btnbox {
    text-align: center;
    margin: 0 20px 100px;

    @screen lg {
        margin: 0 20px 150px;
    }

    .ut-oa-btn-inverse {
        margin-top: 10px;
        @screen sm {
            width: 210px;
            margin-top: 0;
            margin-left: 20px;
        }
    }
}
.pageend {
    display: none;
    background-color: #1A5A4E;
    width: 100%;
    height: 150px;

    @screen lg {
        display: block;
    }
}
.joinus {
    max-width: 900px;

    p {
        margin: auto;
        max-width: 600px;
        padding: 0 20px;

        @screen lg {
            margin: 0;
        }
    }
}
.endshow {
    @screen lg {
        max-width: 243px;
    }
}

.extras {
    border-bottom: 1px solid rgba(#979797, 0.2);
    padding-bottom: 50px;
    @screen lg {
        padding-bottom: 80px;
        display: flex;
    }
    .extrasbox {
        display: flex;
        margin-bottom: 30px;

        @screen lg {
            margin-top: 0;
            display: inline-block;
        }

        .extrasicon {
            margin-top: 0;

            @screen sm {
                height: 160px;
            }
            img {
                width: 65px;
                @screen sm {
                    width: 150px;
                }
                @screen lg {
                    height: stretch;
                    margin: 0 auto;
                    display: block;
                }
            }
        }
        .extrastext {
            margin-top: 0;
            padding-left: 25px;
            width: 230px;
            @screen sm {
                padding-left: 0;
            }
            @screen lg {
                text-align: center;
            }
        }
    }
}

.labimg {
    width: 100%;
    height: 422px;
    background-image: url("../assets/images/laboratory_mobile.svg");
    background-position: center center;
    background-repeat: no-repeat;

    @screen lg {
        background-image: url("../assets/images/laboratory_desktop.svg");
    }
}

.sticky-foot {
    padding: 15px 20px;
    width: stretch;
    position: fixed;
    bottom: 0;
    background-color: #1A5A4E;
    color: #fff;

    @screen lg {
        max-width: 600px;
        right: 0;
        left: 0;
        border-radius: 4px 4px 0 0;
    }

    .chs {
        width: 34px;
        height: 34px;
        float: left;
        margin-right: 10px;
        box-shadow: 0 0 0 1px #fff;
    }

    .agentspace {
        width: 32px;
        height: 32px;
        float: left;
        margin-right: 10px;
        border: 1px dashed rgba(#fff, 0.19);
        border-radius: 50%;
    }

    span {
        font-size: 15px;
        font-weight: normal;
        margin-right: 40px;
        line-height: 34px;
        &:after {
            content: url("../assets/styles/frontend-library/images/arrow-forward.svg");
            position: absolute;
            right: 25px;
            line-height: 50px;
        }
    }
}
.suburbsearchhome {
  max-width: 350px;
}
</style>
